import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import * as Actions from '../../../redux/actions';
import SensorDetail from './SensorDetail';

class SensorDetailContainer extends Component {
  handleApply(sensorData) {
    const { dispatch, stackId, orgId } = this.props;
    sensorData.org = orgId;

    if (!_.isNil(sensorData.id)) {
      dispatch(Actions.Detail.updateSensor(orgId, sensorData, stackId));
    } else {
      dispatch(Actions.Detail.createSensor(orgId, sensorData, stackId));
    }
  }

  handleEditModule(sensor, sensorModule) {
    const { dispatch, stackId } = this.props;
    dispatch(Actions.Detail.presentSensorModuleEdit(sensor, sensorModule, 'primary-sensor-module', stackId));
  }

  handleAddNewModule(sensor) {
    const { dispatch, stackId } = this.props;
    // Remember to tell the new flyout that we are its parent
    // by passing stackId as the parent
    dispatch(Actions.Detail.presentSensorModuleCreate(sensor, 'primary-sensor-module', stackId));
  }

  handleError(error) {
    const { dispatch, stackId } = this.props;
    dispatch(Actions.Detail.reportError(error, stackId));
  }

  render() {
    const {
      sensor = {},
      locations = [],
      orgId,
      mode,
      handleClose,
    } = this.props;

    return (
      <SensorDetail
        orgId={orgId}
        sensor={sensor}
        mode={mode}
        locations={locations}
        handleApply={sensorData => this.handleApply(sensorData)}
        handleEditModule={sensorModule => this.handleEditModule(sensor, sensorModule)}
        handleAddNewModule={() => this.handleAddNewModule(sensor)}
        handleCancel={handleClose}
        handleError={error => this.handleError(error)}
      />);
  }
}

SensorDetailContainer.propTypes = {
  handleClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  mode: PropTypes.string,
  stackId: PropTypes.string.isRequired,
  orgId: PropTypes.string,
  sensor: PropTypes.shape({}),
  locations: PropTypes.instanceOf(Array),
};

SensorDetailContainer.defaultProps = {
  mode: 'edit',
  orgId: '',
  sensor: {},
  locations: [],
};

const mapStateToProps = state => ({}); // eslint-disable-line no-unused-vars

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(SensorDetailContainer);



// WEBPACK FOOTER //
// ./src/views/Components/Detail/SensorDetailContainer.js